import axios from '@/libs/axios'
import { withTenantKey } from '@/libs/storageKeys'

const PARTNER_ROLES = ['ROLE_EXTERNAL_REQUESTER', 'ROLE_EXTERNAL_PARTNER_ADMIN']

const isExternalPartnerUser = () => {
  try {
    const userInfoRaw = localStorage.getItem(withTenantKey('userInfo'))
    if (!userInfoRaw) {
      return false
    }

    const roles = JSON.parse(userInfoRaw)?.roles || []
    return PARTNER_ROLES.some(role => roles.includes(role))
  } catch (error) {
    return false
  }
}

const getAddressReadBasePath = () => (isExternalPartnerUser() ? '/partner/order-requests/addresses' : '/address')
const getAddressWriteBasePath = () => (isExternalPartnerUser() ? '/partner/order-requests/addresses' : '/address')

const normalizePartnerAddressCreatePayload = data => {
  const payload = data && typeof data === 'object' ? data : {}
  const normalizedName = typeof payload.name === 'string' && payload.name.trim() !== '' ? payload.name.trim() : null

  return {
    name: normalizedName,
    address: typeof payload.address === 'string' ? payload.address.trim() : '',
    zip: typeof payload.zip === 'string' ? payload.zip.trim() : '',
    city: typeof payload.city === 'string' ? payload.city.trim() : '',
    private: !!payload.private,
  }
}

export default {
  getAddress: id => axios.get(`${getAddressReadBasePath()}/${id}`),
  findAddress: (searchString, query) => axios.get(`${getAddressReadBasePath()}/find/${searchString}`, { params: query }),
  getAddresses: query => axios.get('/address', { params: query }),
  addAddress: data => (
    isExternalPartnerUser()
      ? axios.post(getAddressWriteBasePath(), normalizePartnerAddressCreatePayload(data))
      : axios.post(getAddressWriteBasePath(), data)
  ),
  updateAddress: (id, data) => axios.put(`/address/${id}`, data),
  patchAddress: (id, data) => axios.patch(`/address/${id}`, data),

  getAddressDetails: id => axios.get(`${getAddressReadBasePath()}/${id}/details`),
  postAddressDetail: (id, data) => axios.post(`/address/${id}/details`, data),
  patchAddressDetail: (addressId, addressDetailId, data) => axios.patch(
    `/address/${addressId}/details/${addressDetailId}`,
    data,
  ),
}
